import http from '../../http';

const state = {
    menu: [],
    selected: ''
};

const mutations = {
    SET_MENU: (state, data) => {
        // 将数据存储为 以 id 为 KEY 的 map 索引数据列
        let map = {};
        let title = '';
        data.forEach(function (item) {
            title = item.menuName;
            let product_item = {};
            product_item.id = item.pkMenuItem;
            product_item.label = item.name;
            product_item.link = item.path;
            product_item.faid = item.faMenuItem;
            //product_item.showFlag = item.pkPersonalization;
            // product_item.route = item.route;
            product_item.leafNode = item.leafNode;
            product_item.icon = item.menuIcon;
            map[product_item.id] = product_item;
        });
        let val = [];
        data.forEach(function (item) {
            // 以当前遍历项，的pid,去map对象中找到索引的id
            let parent = map[item.faMenuItem];
            let myself = map[item.pkMenuItem];
            // 如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
            if (parent) {
                (parent.childs || (parent.childs = [])).push(myself);
            } else {
                //如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
                val.push(myself);
            }
        });

        let menu = {};
        menu.menus = val;
        menu.title = title;
        state.menu = menu;
    },
    SET_SELECTED: (state, {index}) => {
        state.selected = index;
    }
};
const getters = {
    getMenuItem: (state) => (path) => {
        let menuItem = state.menu.menus.find((item) => item.id === path[0]);
        if (path.length === 1) {
            return menuItem;
        }
        for (let i = 1; i < path.length; i++) {
            menuItem = menuItem.childs.find((item) => item.id === path[i]);
        }
        return menuItem;
    }
};

const actions = {
    loadMenu: ({commit}, payload) => {
        http.post('/supplier-resource/system/menuItem/list', {}).then((res) => {
            commit('SET_MENU', res.data.data);
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
